/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { createAction } from '../../../../utils/redux-utils';
import {
    CashboxLocationData,
    GpsTrackingLocationsList,
    HistoryLocationsFilterParams,
    HistoryLocationsList,
    HistoryLocationsQueryParams,
} from '../../../api/cashBoxes/cashBoxesClient.typings';
import { NOTIFICATION_TYPES, Notification } from '../../../../utils/utils';
import { i18n } from '../../../translation/i18n';

export enum CashBoxGpsTrackingTabActionType {
    OPEN_GPS_TRACKING_TAB = 'CashBoxGpsTrackingTab/ open tab',
    EXIT_GPS_TRACKING_TAB = 'CashBoxGpsTrackingTab/ exit tab',
    FETCH_CASHBOX_LOCATION_DATA_SUCCESS = 'CashBoxGpsTrackingTab/ fetch cashbox location data success',
    FETCH_CASHBOX_LOCATION_DATA_ERROR = 'CashBoxGpsTrackingTab/ fetch cashbox location data error',
    FETCH_HISTORY_LOCATIONS_NEXT_PAGE_START = 'CashBoxGpsTrackingTab/ fetch next page of history locations',
    APPLY_HISTORY_LOCATIONS_FILTERING = 'CashBoxGpsTrackingTab/ apply history locations filtering',
    FETCH_CASHBOX_HISTORY_LOCATIONS_PAGE_SUCCESS = 'CashBoxGpsTrackingTab/ fetch cashbox history locations page success',
    FETCH_CASHBOX_HISTORY_LOCATIONS_PAGE_ERROR = 'CashBoxGpsTrackingTab/ fetch cashbox history locations page error',
    FETCH_CAHSBOX_GPS_TRACKING_START = 'CashBoxGpsTrackingTab/ fetch cashbox gps tracking data',
    FETCH_CASHBOX_GPS_TRACKING_SUCCESS = 'CashBoxGpsTrackingTab/ fetch cashbox gps tracking data success',
    FETCH_CASHBOX_GPS_TRACKING_ERROR = 'CashBoxGpsTrackingTab/ fetch cashbox gps tracking data error',
}

export const exitGpsTrackingTabAction = () => createAction(CashBoxGpsTrackingTabActionType.EXIT_GPS_TRACKING_TAB);

export const openGpsTrackingTabAction = (taxNumber: string) =>
    createAction(CashBoxGpsTrackingTabActionType.OPEN_GPS_TRACKING_TAB, { taxNumber });

export const fetchCashboxLocationDataSuccessAction = (payload: CashboxLocationData) =>
    createAction(CashBoxGpsTrackingTabActionType.FETCH_CASHBOX_LOCATION_DATA_SUCCESS, payload);

export const fetchCashboxLocationDataErrorAction = (notification: Notification) =>
    createAction(CashBoxGpsTrackingTabActionType.FETCH_CASHBOX_LOCATION_DATA_ERROR, { notification });

export const fetchGpsLocationsHistoryAction = (taxNumber: string, params: HistoryLocationsQueryParams) =>
    createAction(CashBoxGpsTrackingTabActionType.APPLY_HISTORY_LOCATIONS_FILTERING, { taxNumber, params });

export const fetchCashboxHistoryLocationsPageSuccessAction = (list: HistoryLocationsList) =>
    createAction(CashBoxGpsTrackingTabActionType.FETCH_CASHBOX_HISTORY_LOCATIONS_PAGE_SUCCESS, {
        list,
        notification: list.items.length === 0 && {
            type: NOTIFICATION_TYPES[1],
            message: i18n.t('RegistryScreens.noDataForLocationsHistory'),
        },
    });

export const fetchCashboxHistoryLocationsPageErrorAction = (notification: Notification) =>
    createAction(CashBoxGpsTrackingTabActionType.FETCH_CASHBOX_HISTORY_LOCATIONS_PAGE_ERROR, { notification });

export const fetchGpsTrackingListStartAction = (taxNumber: string, params: HistoryLocationsFilterParams) =>
    createAction(CashBoxGpsTrackingTabActionType.FETCH_CAHSBOX_GPS_TRACKING_START, { taxNumber, params });

export const fetchGpsTrackingListSuccessAction = (list: GpsTrackingLocationsList) =>
    createAction(CashBoxGpsTrackingTabActionType.FETCH_CASHBOX_GPS_TRACKING_SUCCESS, {
        list,
        notification:
            list.items.length === 0
                ? {
                      type: NOTIFICATION_TYPES[1],
                      message: i18n.t('RegistryScreens.noDataForTrackingHistory'),
                  }
                : null,
    });

export const fetchGpsTrackingListErrorAction = (notification: Notification) =>
    createAction(CashBoxGpsTrackingTabActionType.FETCH_CASHBOX_GPS_TRACKING_ERROR, { notification });

export type CashBoxGpsTrackingTabAction =
    | ReturnType<typeof exitGpsTrackingTabAction>
    | ReturnType<typeof openGpsTrackingTabAction>
    | ReturnType<typeof fetchCashboxLocationDataSuccessAction>
    | ReturnType<typeof fetchCashboxLocationDataErrorAction>
    | ReturnType<typeof fetchGpsLocationsHistoryAction>
    | ReturnType<typeof fetchCashboxHistoryLocationsPageSuccessAction>
    | ReturnType<typeof fetchCashboxHistoryLocationsPageErrorAction>
    | ReturnType<typeof fetchGpsTrackingListStartAction>
    | ReturnType<typeof fetchGpsTrackingListSuccessAction>
    | ReturnType<typeof fetchGpsTrackingListErrorAction>;
